import React from "react";
import { Navigate } from "react-router-dom";
import { useTypedSelector } from "../../store/index.ts";

interface ProtectedRouteProps {
  Element: React.FC;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  Element,
  redirectTo = "/",
}) => {
  const userSession = useTypedSelector((state) => state.session.user);

  // if not online redirect to
  if (!userSession?.accessToken) return <Navigate to={redirectTo} />;

  // If authenticated render the element
  return <Element />;
};

export default ProtectedRoute;
